'use client';

import { useTranslation } from '@whoop/i18n/lang/client';
import RichTextRenderer from 'ui/components/RichTextRenderer/RichTextRenderer';
import type { PageDisclaimer } from '@/lib/constants/maverick';
import { forwardRef } from 'react';
interface DisclaimersProps {
  pageDisclaimers: PageDisclaimer[] | undefined;
}
export default forwardRef<HTMLDivElement, DisclaimersProps>(({
  pageDisclaimers
}, ref): JSX.Element | null => {
  const {
    t
  } = useTranslation('membershipTiers');
  if (!pageDisclaimers) {
    return null;
  }
  return <div className='flex w-full scroll-mt-14 justify-center' ref={ref}>
        <div className='text-gray-b50 flex w-[88%] max-w-screen-lg list-none flex-col items-start justify-start px-4 pb-12 pt-8 text-sm font-normal leading-4' data-testid='disclaimers'>
          <div className='text-body-md pb-2 font-semibold'>
            {t('disclaimers')}
          </div>
          {pageDisclaimers.map(disclaimer => {
        return <li className='mb-4 last:mb-0' key={disclaimer.name} data-testid='page-disclaimer'>
                <RichTextRenderer content={disclaimer.content.json} />
              </li>;
      })}
        </div>
      </div>;
});